import { register, defineProperty, defineRelation, Direction } from 'olympe';
import FactorTarget from './FactorTarget';
import Influence from "./Influence";

/**
 * @extends {FactorTarget}
 */
export default class Aspect extends FactorTarget {

    /**
     * @return {string}
     */
    getName() {
        return this.get(Aspect.nameProp);
    }

    /**
     * @return {Color}
     */
    getColor() {
        return this.get(Aspect.colorProp);
    }
}

// Hardcoded tags
register('01880b43171172dd6c36', Aspect);
Aspect.nameProp = defineProperty('01880b43e602bdf8daf6');
Aspect.colorProp = defineProperty('01880b4410441506a9f7');
Aspect.influencesRel = defineRelation('01894f1028cd94191541', Aspect, Influence);
Aspect.inverse_aHPValueaspectRel = defineRelation('01880b43842faecab448', Direction.ORIGIN);
